export const ResultType = {
    sixMonths: '6-months',
    threeMonths: '3-months'
};
